// extracted by mini-css-extract-plugin
export default {"hideTooltip":"X_-z","fadeIn":"Y_-z","delay":"Z_-z","recommendedSizeTooltip":"__-z"};